/**
 * Shared thresholds and tone mapping for the Organization Profile completion
 * nudges. Kept in one place so the badge, banner and tooltip stay consistent.
 */

/** At or above this completion %, the Assessments Home banner stops showing. */
export const COMPLETION_BANNER_THRESHOLD = 50;

/** At or above this completion %, the profile is treated as healthy (no alarm). */
export const COMPLETION_HEALTHY_THRESHOLD = 90;

export type CompletionTone = 'success' | 'warning' | 'error';

/**
 * Maps a completion percentage to a theme palette tone:
 * healthy (>=90) -> success, partial (>=50) -> warning, low (<50) -> error.
 */
export function completionTone(progressPct: number): CompletionTone {
  if (progressPct >= COMPLETION_HEALTHY_THRESHOLD) return 'success';
  if (progressPct >= COMPLETION_BANNER_THRESHOLD) return 'warning';
  return 'error';
}

/**
 * Whether the Assessments Home banner should show. Strictly below 50% — at
 * exactly 50% the banner is gone (the "at least" rule for the threshold).
 */
export function shouldShowCompletionBanner(progressPct: number): boolean {
  return progressPct < COMPLETION_BANNER_THRESHOLD;
}

/**
 * Whether the New Assessment popup should show: only when zero fields are
 * filled and it has not been suppressed for this user/org. Exactly one filled
 * field suppresses it (the "at least one field" rule).
 */
export function shouldShowCompletionPopup(
  fieldsFilled: number,
  popupSuppressed: boolean,
): boolean {
  return fieldsFilled === 0 && !popupSuppressed;
}
